module.exports = __webpack_public_path__ + "img/kim.e380c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kim.png
// module id = Z2Ye
// module chunks = 8